define('lib/view/CompositeView',['require','lib/view/BaseCompositeView'],function (require) {

    var Parent = require('lib/view/BaseCompositeView');

    /**
     * Common Composite view
     *
     * @class CompositeView
     */
    return Parent.extend({

    });

});
